module.exports = __webpack_public_path__ + "static/3A841E_0_0-143ba5df45b9ff85d6f08855f9f58a03.woff2";